var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunloop2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.703,
    height: 36.047,
    viewBox: "0 0 31.703 36.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21632",
    "data-name": "\\uADF8\\uB8F9 21632",
    transform: "translate(0.85 1.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10222",
    "data-name": "\\uD328\\uC2A4 10222",
    d: "M180.458,179.151H155.326a1.819,1.819,0,0,1-1.862-1.772v-8.27a1.956,1.956,0,0,1,.545-1.308,2.915,2.915,0,0,1,2.186-.907h23.4a2.913,2.913,0,0,1,2.185.907,1.951,1.951,0,0,1,.545,1.308v8.27A1.818,1.818,0,0,1,180.458,179.151Z",
    transform: "translate(-152.998 -147.972)",
    fill: "none",
    stroke: "#adb5bd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10223",
    "data-name": "\\uD328\\uC2A4 10223",
    d: "M180.889,167.036H155.447l3.232-7.272a1.86,1.86,0,0,1,1.7-1.106h15.577a1.861,1.861,0,0,1,1.7,1.106Z",
    transform: "translate(-152.964 -148.112)",
    fill: "none",
    stroke: "#adb5bd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10224",
    "data-name": "\\uD328\\uC2A4 10224",
    d: "M155.333,164.353h-1.551c-.429,0-.776-.5-.776-1.115s.347-1.114.776-1.114h2.809l-.69,2.228Z",
    transform: "translate(-153.006 -148.053)",
    fill: "none",
    stroke: "#adb5bd",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10225",
    "data-name": "\\uD328\\uC2A4 10225",
    d: "M180.239,164.353h1.551c.429,0,.776-.5.776-1.115s-.347-1.114-.776-1.114h-2.809l.69,2.228Z",
    transform: "translate(-152.563 -148.053)",
    fill: "none",
    stroke: "#adb5bd",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10226",
    "data-name": "\\uD328\\uC2A4 10226",
    d: "M161.2,172.974a1.575,1.575,0,1,1-1.575-1.575A1.575,1.575,0,0,1,161.2,172.974Z",
    transform: "translate(-152.92 -147.895)",
    fill: "none",
    stroke: "#adb5bd",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10227",
    "data-name": "\\uD328\\uC2A4 10227",
    d: "M176.716,172.974a1.575,1.575,0,1,1-1.575-1.575A1.575,1.575,0,0,1,176.716,172.974Z",
    transform: "translate(-152.656 -147.895)",
    fill: "none",
    stroke: "#adb5bd",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28085",
    "data-name": "\\uC0AC\\uAC01\\uD615 28085",
    width: 5.585,
    height: 2.483,
    rx: 0.416,
    transform: "translate(3.724 31.334)",
    fill: "none",
    stroke: "#adb5bd",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28086",
    "data-name": "\\uC0AC\\uAC01\\uD615 28086",
    width: 5.585,
    height: 2.483,
    rx: 0.416,
    transform: "translate(19.936 31.334)",
    fill: "none",
    stroke: "#adb5bd",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_62",
    "data-name": "\\uC120 62",
    y1: 5.849,
    transform: "translate(15.534)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_63",
    "data-name": "\\uC120 63",
    x1: 3.493,
    y1: 2.225,
    transform: "translate(15.534)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_64",
    "data-name": "\\uC120 64",
    y1: 2.225,
    x2: 3.493,
    transform: "translate(12.041)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunloop2);
export default __webpack_public_path__ + "static/media/Sunloop2.0eeaa8ee537fa01e86cf334e105a967f.svg";
export { ForwardRef as ReactComponent };